<template>
  <div id="index" style="overflow-x:hidden">


    <div class="to-top" @click="toTop" v-if="showToTop" ><i class="el-icon-arrow-up" style="line-height: 1.8vw"></i></div>


    <NavHeader
      :status="{
        page:'home',
        produce:false,
        solution:false
      }"
    />




    <div class="main" >


      <div class="produce-title">
        <div class="produce-back"></div>
      </div>

      <div class="produce">
        <div class="produce-medium-card produce-card-1" >
          <div class="produce-card-text">
            <p style="font-weight: 1000;margin-bottom: 1vw;letter-spacing: 1px">虚拟仿真物理实验</p>
            <p style="font-weight:100;font-size: 0.9em">涵盖传统物理学科电热声光磁所有实验及中考所考的实验，为学生和老师搭建自由操作的3D/VR实验平台</p>
          </div>
          <div class="produce-card-btn" style="color: #5eb2f7;box-shadow: rgba(94,178,247,0.59) 2px 4px 5px" @click="$router.push('/produce/physical')">查看更多</div>
        </div>
        <div class="produce-medium-card produce-card-2" >
          <div class="produce-card-text">
            <p style="font-weight: 1000;margin-bottom: 1vw;letter-spacing: 1px">虚拟仿真化学实验</p>
            <p style="font-weight:100;font-size: 0.9em">提供高仿真的化学实验场景，实现操作深度自由交互，降低实验耗材成本，规避实验风险</p>
          </div>
          <div class="produce-card-btn" style="color: rgb(164,160,71);box-shadow: rgba(236,231,100,0.59) 2px 4px 5px" @click="$router.push('/produce/chemistry')">查看更多</div>
        </div>
        <div class="produce-medium-card produce-card-3">
          <div class="produce-card-text">
            <p style="font-weight: 1000;margin-bottom: 1vw;letter-spacing: 1px">虚拟仿真生物实验</p>
            <p style="font-weight:100;font-size: 0.9em">通过仿真算法直观展示生物实验全过程、长周期、微观生物构造等实验现象</p>
          </div>
          <div class="produce-card-btn" style="color: rgb(118,209,134);box-shadow: rgba(118,209,134,0.59) 2px 4px 5px" @click="$router.push('/produce/biology')">查看更多</div>
        </div>
        <div class="produce-medium-card produce-card-5" >
          <div class="produce-card-text">
            <p style="font-weight: 1000;margin-bottom: 1vw;letter-spacing: 1px">VR课程体系</p>
            <p style="font-weight:100;font-size: 0.9em">VR课程覆盖实验教学、校园安全、红色教育等资源，给师生打造完全沉浸式的教学学习体验</p>
          </div>
          <div class="produce-card-btn" style="color: rgb(255,164,0);box-shadow: rgba(255,164,0,0.6) 2px 4px 5px" @click="$router.push('/produce/VR')">查看更多</div>
        </div>
      </div>


      <div class="solution-title-back">
        <div class="solution-title"></div>
      </div>



      <div class="solution">
        <div style="position:relative;  display: flex;flex-wrap: nowrap;flex-direction: row;width: 88vw;background-color:rgb(156,168,175);">
          <div class="solution-card1" :class="{'active-solution-card':activeSolutionCard===1}" @click="changeActive(1)" >
            <div class="card-mask" :style="{backgroundColor: activeSolutionCard===1?'rgba(0,0,0,.6)':''}">
              <div v-show="activeSolutionCard===1" style="display: flex;flex-direction: column;justify-content: center;width: 75%;height: 100%;align-items: center;color: white;text-align: center;margin: auto;font-size: 1vw;font-family: test">
                <div style="margin: 2vw 0 2vw;">{{solutionCard1Title}}</div>
                <div class="solution-line"></div>
                <div style="margin: 2vw 0 2vw;">{{solutionCard1Text}}</div>

                <div class="solution-more-btn" @click="toSolution">查看更多</div>
              </div>
              <div v-show="activeSolutionCard!==1" style="display: flex;flex-direction: column;justify-content: center;width: 75%;height: 100%;align-items: center;color: white;text-align: center;margin: auto;font-size: 1vw;font-family: test">
                <div class="classroom-pic" ref="solution-card-icon-1"></div>
                <div class="solution-line"></div>
                <div style="margin: 2vw 0 2vw;">{{solutionCard1Title}}</div>
              </div>

            </div>
          </div>
          <div class="solution-card2" :class="{'active-solution-card':activeSolutionCard===2}" @click="changeActive(2)" >
            <div class="card-mask" :style="{backgroundColor: activeSolutionCard===2?'rgba(0,0,0,.6)':''}">
              <div v-show="activeSolutionCard===2" style="display: flex;flex-direction: column;justify-content: center;width: 75%;height: 100%;align-items: center;color: white;text-align: center;margin: auto;font-size: 1vw;font-family: test">
                <div style="margin: 2vw 0 2vw;">{{solutionCard2Title}}</div>
                <div class="solution-line"></div>
                <div style="margin: 2vw 0 2vw;">{{solutionCard2Text}}</div>

                <div class="solution-more-btn" @click="toSolution">查看更多</div>
              </div>
              <div v-show="activeSolutionCard!==2" style="display: flex;flex-direction: column;justify-content: center;width: 75%;height: 100%;align-items: center;color: white;text-align: center;margin: auto;font-size: 1vw;font-family: test">
                <div class="math-pic" ref="solution-card-icon-2"></div>
                <div class="solution-line"></div>
                <div style="margin: 2vw 0 2vw;">{{solutionCard2Title}}</div>
              </div>

            </div>
          </div>
          <div class="solution-card3" :class="{'active-solution-card':activeSolutionCard===3}" @click="changeActive(3)" >
            <div class="card-mask" :style="{backgroundColor: activeSolutionCard===3?'rgba(0,0,0,.6)':''}">
              <div v-show="activeSolutionCard===3" style="display: flex;flex-direction: column;justify-content: center;width: 75%;height: 100%;align-items: center;color: white;text-align: center;margin: auto;font-size: 1vw;font-family: test">
                <div style="margin: 2vw 0 2vw;">{{solutionCard3Title}}</div>
                <div class="solution-line" ></div>
                <div style="margin: 2vw 0 2vw;">{{solutionCard3Text}}</div>

                <div class="solution-more-btn" @click="toSolution">查看更多</div>
              </div>
              <div v-show="activeSolutionCard!==3" style="display: flex;flex-direction: column;justify-content: center;width: 75%;height: 100%;align-items: center;color: white;text-align: center;margin: auto;font-size: 1vw;font-family: test">
                <div class="exam-pic" ref="solution-card-icon-3"></div>
                <div class="solution-line"></div>
                <div style="margin: 2vw 0 2vw;">{{solutionCard3Title}}</div>
              </div>

            </div>
          </div>
        </div>
        <div class="solution-right-btn" :style="{backgroundColor:count%2===1?'rgb(156,168,175)':'rgb(156,168,175)'}">
          <div class="right" @click="switchSolutionCard" >
            <i class="el-icon-caret-right right-in" style="font-size: 2vw;font-weight: 1000;color: white" ref="solutionBtn"></i>
          </div>
        </div>
      </div>
      <div style="background-color: white;color: #5eb2f7;font-weight: bold;font-size: 1.3vw;font-family: test;text-align: center;width: 100%;height: 5vw;line-height: 5vw;margin-bottom: 5vw;cursor: default">纵深精耕&nbsp;&nbsp;覆盖全场景解决方案</div>

      <div class="video-title">
        <div class="video-left-in"></div>
        <div class="video-right-in"></div>
        <div class="video-back">
          <div class="video-text">
            <div class="video-text-group">
              <div class="video-text-up" ><span id="value1">0</span><span>+</span></div>
              <div class="video-text-down">模型数量</div>
            </div>
            <div class="video-text-group">
              <div class="video-text-up"><span id="value2">0</span><span>+</span></div>
              <div class="video-text-down">实验数量</div>
            </div>
            <div class="video-text-group">
              <div class="video-text-up"><span id="value3">0</span><span>+</span></div>
              <div class="video-text-down">支持平台及系统</div>
            </div>
          </div>
        </div>
      </div>


      <div style="width: 60vw;margin:3.5vw 20vw 27.6vw;border: 2px white solid;box-shadow: 0 2px 4px rgba(111,165,196,.4), 0 0 6px rgba(0, 0, 0, .04)">
        
          <vue-plyr :options="videoOption" >
            <video poster="http://data.xiyilab.com/web/main/static/首页/视频封面.jpg"
                   :controls="false"
                   src="https://data.xiyilab.com/videos/%E8%9C%A5%E7%BF%BC%E8%99%9A%E6%8B%9F%E4%BB%BF%E7%9C%9F%E5%AE%9E%E9%AA%8C%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91-2021.6.10.mp4">
            </video>
          </vue-plyr>
        
      </div>



      <div class="usage-title">
        <div class="usage-back"></div>
        <div class="move-back"></div>
      </div>

      <div class="usage">
        <div class="usage-card-group">
          <div class="usage-card-group-left">
            <div class="usage-large-card">
              <div  class="bigger-img"></div>
              <div class="usage-card-title">普通教室</div>
            </div>
          </div>
          <div class="usage-card-group-right">
            <div class="usage-medium-card" >
              <div class="medium-img-1"></div>
              <div class="usage-card-title">多媒体教室</div>
            </div>
            <div class="usage-medium-card" style="margin-top: auto">
              <div class="medium-img-2"></div><div class="usage-card-title">理化生实验教室</div>
            </div>
          </div>
        </div>
        <div class="usage-card-group">
          <div class="usage-mini-card"><div class="mini-img-1"></div><div class="usage-card-title">创新教室</div></div>
          <div class="usage-mini-card"><div class="mini-img-2"></div><div class="usage-card-title">考试实训</div></div>
          <div class="usage-mini-card"><div class="mini-img-3"></div><div class="usage-card-title">日常练习</div></div>
        </div>
      </div>
      <div class="usage-line"></div>

      <div class="case-title"></div>

      <div class="case">
        <div class="case-switch-zone">
          <div class="switch-btn"  @click="switchCaseCard('right')">
            <i class="el-icon-back"></i>
          </div>
          <div class="switch-zone">
            <div class="case-card-0" style="background-image: url('http://data.xiyilab.com/web/main/static/首页/长安第二初级中学.png');"></div>
            <div class="case-card-1" style="background-image: url('http://data.xiyilab.com/web/main/static/首页/陕西省教育厅副厅长赵昶葆莅临指导.png');"></div>
            <div class="case-card-2" style="background-image: url('http://data.xiyilab.com/web/main/static/首页/西安车辆中学.png');"></div>
            <div class="case-card-3" style="background-image: url('http://data.xiyilab.com/web/main/static/首页/沣东新城第一初级中学.png');"></div>
            <div class="case-card-4" style="background-image: url('http://data.xiyilab.com/web/main/static/首页/国际港务区铁一中陆港中学.png');"></div>
          </div>
          <div class="switch-btn" @click="switchCaseCard('left')">
            <i class="el-icon-right"></i>
          </div>
        </div>
        <div class="case-more-btn">查看更多</div>
      </div>


      <div class="footer-img">
        <div style="font-family: test;font-size: 1.2vw;color: white;font-weight: 100;cursor: default">让我们一起育见未来</div>
        <div class="footer-btn-group">
          <div class="footer-btn">立即试用</div>
        </div>
      </div>
    </div>




    <Footer/>
  </div>

</template>


<script>
import Footer from '@/components/Footer'
import NavHeader from '@/components/NavHeader'
import $ from 'jquery'
import { test } from '@/api/test'
import DevicePixelRatio from "@/plugins/devicePixelRatio";
export default {
  components:{
    Footer,
    NavHeader
  },
  created() {
      new DevicePixelRatio().init();

  },
  data(){
    return{
      showToTop:false,
      solution:'/solution?title=classroom',
      count:1,
      activeSolutionCard:1,
      videoOption:{
        i18n: {
          speed: '速度',
          normal: '正常',
          captions:'字幕',
          disabled:'禁用',
          chinese:'中文'
        },
      },
      moveBackFlag:0,
      leftFlag:0,
      changeTimer:null,
      rightFlag:0,
      timer:null,
      leftHidden:0,
      rightHidden:4,
      solutionCard1Title:'常态化教学解决方案',
      solutionCard1Text:'虚拟仿真实验系统可安装在普通教室的一体、多媒体机房，方便教师进行实验教学和学生实验练习及模拟考核',
      solutionCard2Title:'数字化探究实验室解决方案',
      solutionCard2Text:'应用于传统理化生实验室，达到虚实结合的效果，实验教学效果更佳',
      solutionCard3Title:'理化生实操考试综合解决方案',
      solutionCard3Text:'理化生实操考试由“教考评一体化”平台及考场实验设备两部分组成，方便学校大规模组织学生进行练习和实验考核',
      openDate:''
    }
  },
  mounted () {

    this.openDate=new Date()
    // console.log(1234)
    if(window){
      $('.move-back').animate({
        top:'7vw'
      },5000)
      $('.move-back').animate({
        top:'0vw'
      },5000)
      this.timer=setInterval(()=>{
        $('.move-back').animate({
          top:'7vw'
        },5000)
        $('.move-back').animate({
          top:'0vw'
        },5000)
      },10000)
      window.addEventListener('mousewheel',(e)=>{
        if(e.pageY>1500){
          this.showToTop=true
        }
        else {
          this.showToTop = false
        }
        if($('.video-text-up')[0].getBoundingClientRect().top-window.innerHeight-300<=0&&this.rightFlag===0){
          this.NumAutoPlusAnimation("value1", {
            time: 1500,
            num: 1000,
            regulator: 50
          })
          this.NumAutoPlusAnimation("value2", {
            time: 1500,
            num: 500,
            regulator: 50
          })
          this.NumAutoPlusAnimation("value3", {
            time: 100,
            num: 10,
            regulator: 5
          })
        }
          if($('.video-right-in')[0].getBoundingClientRect().top-window.innerHeight<=0&&this.rightFlag===0){
          $('.video-right-in').animate({
            left:'38vw'
          },500)
          this.rightFlag=1
        }
        if($('.video-left-in')[0].getBoundingClientRect().top-window.innerHeight<=0&&this.leftFlag===0){
          $('.video-left-in').animate({
            left:'-43vw'
          },500)
          this.leftFlag=1
        }
      })
    }
  },
  beforeDestroy () {
    if(window){
      window.removeEventListener('mousewheel',()=>{
        console.log('remove')
      })
    }
    clearInterval(this.timer)
  },
  methods:{
    NumAutoPlusAnimation(targetEle, options) {
  /*可以自己改造下传入的参数，按照自己的需求和喜好封装该函数*/
  //不传配置就把它绑定在相应html元素的data-xxxx属性上吧
  options = options || {};

  var $this = document.getElementById(targetEle),
    time = options.time || $this.data('time'), //总时间--毫秒为单位
    finalNum = options.num || $this.data('value'), //要显示的真实数值
    regulator = options.regulator || 100, //调速器，改变regulator的数值可以调节数字改变的速度

    step = finalNum / (time / regulator),/*每30ms增加的数值--*/
    count = 0, //计数器
    initial = 0;

  var timer = setInterval(function() {

    count = count + step;

    if(count >= finalNum) {
      clearInterval(timer);
      count = finalNum;
    }
    //t未发生改变的话就直接返回
    //避免调用text函数，提高DOM性能
    var t = Math.floor(count);
    if(t == initial) return;

    initial = t;

    $this.innerHTML = initial;
  }, 30);
},
    switchSolutionCard(){
      this.$refs['solutionBtn'].style.transform = 'rotateY('+180*this.count+'deg)';
      this.count++;
      let index=this.count%2===1?1:3
      if(this.activeSolutionCard!==index){
        $('.solution-card'+this.activeSolutionCard).animate({
          width:'25%'
        },500)
        $('.solution-card'+index).animate({
          width:'50%'
        },500)
        this.activeSolutionCard=index
      }
      if(this.count%2===1){
        this.$refs['solution-card-icon-1'].className='classroom-pic'
        this.$refs['solution-card-icon-2'].className='math-pic'
        this.$refs['solution-card-icon-3'].className='exam-pic'
        $('.solution-card1')[0].style.backgroundImage='url("http://data.xiyilab.com/web/main/static/解决方案/常态化教室banner.png")'
        $('.solution-card2')[0].style.backgroundImage='url("http://data.xiyilab.com/web/main/static/解决方案/数字化实验室.png")'
        $('.solution-card3')[0].style.backgroundImage='url("http://data.xiyilab.com/web/main/static/解决方案/理化生实验室banner.png")'
        this.solutionCard1Title='常态化教学解决方案'
        this.solutionCard1Text='虚拟仿真实验系统可安装在普通教室的一体、多媒体机房，方便教师进行实验教学和学生实验练习及模拟考核'

        this.solutionCard2Title='数字化探究实验室解决方案'
        this.solutionCard2Text='应用于传统理化生实验室，达到虚实结合的效果，实验教学效果更佳'
        this.solutionCard3Title='理化生实操考试综合解决方案'
        this.solutionCard3Text='理化生实操考试由“教考评一体化”平台及考场实验设备两部分组成，方便学校大规模组织学生进行练习和实验考核'
        this.solution='/solution?title=classroom'
      }
      else{
        this.solution='/solution?title=xr'
        this.$refs['solution-card-icon-1'].className='math-pic'
        this.$refs['solution-card-icon-2'].className='exam-pic'
        this.$refs['solution-card-icon-3'].className='vr-pic'
        $('.solution-card1')[0].style.backgroundImage='url("http://data.xiyilab.com/web/main/static/解决方案/数字化实验室.png")'
        $('.solution-card2')[0].style.backgroundImage='url("http://data.xiyilab.com/web/main/static/解决方案/理化生实验室banner.png")'
        $('.solution-card3')[0].style.backgroundImage='url("http://data.xiyilab.com/web/main/static/解决方案/创新实验室banner.png")'
        this.solutionCard1Title='数字化探究实验室解决方案'
        this.solutionCard1Text='应用于传统理化生实验室，达到虚实结合的效果，实验教学效果更佳'
          this.solutionCard2Title='理化生实操考试综合解决方案'
          this.solutionCard2Text='理化生实操考试由“教考评一体化”平台及考场实验设备两部分组成，方便学校大规模组织学生进行练习和实验考核'
          this.solutionCard3Title='VR创新实验室解决方案'
          this.solutionCard3Text='虚拟仿真实验软件搭载桌面式VR和沉浸式VR软件及硬件设备，给学生带来沉浸式的实验体验'
      }
    },
    changeActive(cardIndex){
      // if(cardIndex===1){
      //   this.solution='classroom'
      // }
      if(this.count%2===1){
        if(cardIndex===1){
          this.solution='/solution?title=classroom'
        }
        if(cardIndex===2){
          this.solution='/solution?title=math'
        }
        if(cardIndex===3){
          this.solution='/solution?title=physical'
        }
      }
      else{
        if(cardIndex===1){
          this.solution='/solution?title=math'
        }
        if(cardIndex===2){
          this.solution='/solution?title=physical'
        }
        if(cardIndex===3){
          this.solution='/solution?title=xr'
        }
      }
      if(cardIndex!==this.activeSolutionCard){
        $('.solution-card'+this.activeSolutionCard).animate({
          width:'22vw'
        },500)
        $('.solution-card'+cardIndex).animate({
          width:'44vw'
        },500)
        this.activeSolutionCard=cardIndex
      }
      // if(cardIndex>this.activeSolutionCard){
      //
      //   $('.solution-card'+this.activeSolutionCard).animate({
      //     width:'20vw',
      //     left:(this.activeSolutionCard-1)*20+'vw'
      //   },500)
      //   if(cardIndex-1===this.activeSolutionCard){
      //     $('.solution-card'+cardIndex).animate({
      //       width:'40vw',
      //       left:(cardIndex-1)*20+'vw'
      //     },500)
      //   }
      //   else {
      //     $('.solution-card'+(this.activeSolutionCard+1)).animate({
      //       width:'20vw',
      //       left:(cardIndex-2)*20+'vw'
      //     },500)
      //     $('.solution-card'+cardIndex).animate({
      //       width:'40vw',
      //       left:(cardIndex-1)*20+'vw'
      //     },500)
      //   }
      //   this.activeSolutionCard=cardIndex
      // }
      // if(cardIndex<this.activeSolutionCard){
      //   $('.solution-card'+this.activeSolutionCard).animate({
      //     width:'20vw',
      //     left:(this.activeSolutionCard)*20+'vw'
      //   },500)
      //   if(cardIndex+1===this.activeSolutionCard){
      //
      //     $('.solution-card'+cardIndex).animate({
      //       width:'40vw',
      //       left:(cardIndex-1)*20+'vw'
      //     },500)
      //   }
      //   else{
      //     $('.solution-card'+(this.activeSolutionCard-1)).animate({
      //       width:'20vw',
      //       left:(cardIndex+1)*20+'vw'
      //     },500)
      //     $('.solution-card'+cardIndex).animate({
      //       width:'40vw',
      //       left:(cardIndex-1)*20+'vw'
      //     },500)
      //   }
      //   this.activeSolutionCard=cardIndex
      // }

    },
    fadeout(){
      console.log($('.test')[0].style.left)

      $('.test').animate({
        left:200+'px'
      })
    },
    switchCaseCard(position){
      let now=new Date()


      if(now-this.openDate>500){
        if(position==='left'){
          $('.case-card-'+(this.leftHidden)%5)[0].hidden=true
          $('.case-card-'+(this.leftHidden+1)%5).animate({
            left:'-20vw'
          },500)
          $('.case-card-'+(this.leftHidden+2)%5).animate({
            left:'0vw'
          },500)
          $('.case-card-'+(this.leftHidden+3)%5).animate({
            left:'22vw'
          },500)
          $('.case-card-'+(this.leftHidden+4)%5).animate({
            left:'44vw'
          },500)
          $('.case-card-'+(this.leftHidden)%5)[0].style.left='66vw'
          $('.case-card-'+(this.leftHidden)%5)[0].hidden=false

          this.leftHidden=(this.leftHidden+1)%5

        }
        else{
          $('.case-card-'+(this.leftHidden+4)%5)[0].hidden=true
          $('.case-card-'+(this.leftHidden+4)%5)[0].style.left='-20vw'

          $('.case-card-'+(this.leftHidden+3)%5).animate({
            left:'66vw'
          },500)
          $('.case-card-'+(this.leftHidden+2)%5).animate({
            left:'44vw'
          },500)
          $('.case-card-'+(this.leftHidden+1)%5).animate({
            left:'22vw'
          },500)
          $('.case-card-'+this.leftHidden).animate({
            left:'0vw'
          },500)
          $('.case-card-'+(this.leftHidden+4)%5)[0].hidden=false


          this.leftHidden=(this.leftHidden+4)%5
        }
        this.openDate=now
        // $('.case-card-'+(this.leftHidden)%5)[0].style.backgroundImage=$('.case-card-'+(this.leftHidden+3)%5)[0].style.backgroundImage
        // $('.case-card-'+(this.leftHidden+4)%5)[0].style.backgroundImage=$('.case-card-'+(this.leftHidden+1)%5)[0].style.backgroundImage
      }
    },
    toTop(){
      $('.to-top').fadeOut(100)
      this.showToTop=false
      $('body,html').animate({
          scrollTop: 0
        },
        500);
    },

    toSolution(){
      this.$router.push(this.solution)
    }
  }
}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');
.boxchilde{
  display: inline-block;
  margin-top: 2vw;
  margin-right: 2.5vw;
  width: 18vw;
  height: 14vw;
  -webkit-transition: all 0.6s ease-in;
  -moz-transition: all 0.6s ease-in;
  -ms-transition: all 0.6s ease-in;
  -o-transition: all 0.6s ease-in;
  transition: all 0.6s ease-in;
  overflow: hidden;
}
.boxchilde:hover{
  cursor: pointer;
  -webkit-transform: translate(0,-10px);
  -moz-transform: translate(0,-10px);
  -ms-transform: translate(0,-10px);
  -o-transform: translate(0,-10px);
  transform: translate(0,-10px);
}

.header {
  position: relative;
  width: 100vw;
  height: 42vh;
}


.main {
  width: 100vw;
  margin-top: 25vw;
  margin-bottom: 0;
  position: relative;

}
.produce{
  height: 32.5vw;
  width: 62.5vw;
  margin:3.75vw auto 5vw;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.produce-large-card{
  width: 41.3vw;
  height: 15vw;
  cursor: default;
  color: white;
  transition: all 0.3s;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
.produce-large-card:hover{
  color: white;
}
.produce-medium-card{
  width: 20vw;
  height: 15vw;
  cursor: default;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  color: white;
  transition: all 0.3s;
}
.produce-medium-card:hover{
  color: white;
}
.produce-card-1{
  transition: all 0.3s;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/物理实验1.png");
}
.produce-card-2{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/化学实验1.png");
}
.produce-card-3{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/生物实验1.png");
}
.produce-card-4{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/模考.png");
}
.produce-card-5{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/VR1.png");
}
.produce-card-1:hover{
  transform: scale(1.05);
}
.produce-card-2:hover{
  transform: scale(1.05);
}
.produce-card-3:hover{
  transform: scale(1.05);
}
.produce-card-4:hover{
  transform: scale(1.05);
}
.produce-card-5:hover{
  transform: scale(1.05);
}
.produce-card-text{
  font-family: test;
  width: 80%;
  height: 50%;
  margin: 2vw auto 1.5vw;
  text-align: left;
  line-height: 1.5vw;
  font-size: 0.9vw;
}
.produce-card-btn{
  width: 5vw;
  text-align: center;
  letter-spacing: 1px;
  height:1.5vw;
  line-height: 1.5vw;
  border-radius: 2vw;
  font-size: 0.8vw;
  margin: auto 2vw auto;
  background-color: white;
  cursor: pointer;
  transition: all 0.5s ease;
}

.solution{
  width: 100vw;
  height: 31.25vw;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  margin: 0vw 0 0;
}
.solution-right-btn{
  height: 100%;
  width: 12vw;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/箭头下背景.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.right-in{
  transition: all 0.5s ease;
}

.solution-card1{
  width: 25%;
  height: 100%;
  background-size: cover;
  background: url("http://data.xiyilab.com/web/main/static/解决方案/常态化教室banner.png") no-repeat  center;
  position: relative;

}
.card-mask{
  height:100%;
  width:100%;
  background-color: rgba(0,0,0,.6);
}
.solution-line{
  background-image: linear-gradient(90deg,
  #04abff 0%,
  #4f75fb 100%),
  linear-gradient(
    #5c6c7a,
    #5c6c7a);
  background-blend-mode: normal,
  normal;
  width: 3vw;
  height: 3px;
}
.solution-more-btn{
  height: 1.8vw;
  line-height: 1.8vw;
  width: 7rem;
  font-size: 0.7vw;
  border-radius: 1.8vw;
  color: #5eb2f7;
  background: white;
  font-weight: 800;
  font-family: test;
  cursor: pointer;
}
.classroom-pic{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/icon_教学.png");
  width: 3.6vw;
  height: 3.6vw;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-bottom: 2vw;
}
.vr-pic{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/icon_VR.png");
  width: 3.6vw;
  height: 3.6vw;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-bottom: 2vw;
}
.math-pic{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/icon_数字化.png");
  width: 3.6vw;
  height: 3.6vw;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-bottom: 2vw;
}
.exam-pic{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/icon_实操考试.png");
  width: 3.6vw;
  height: 3.6vw;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  margin-bottom: 2vw;
}
.active-card{
  background-color: transparent;
}
.solution-card1:hover .card-mask{
  background-color: transparent;
  transition: all 0.5s;
}
.solution-card2{
  position: relative;
  width: 25%;
  height: 100%;
  background-size: cover;
  background: url("http://data.xiyilab.com/web/main/static/解决方案/数字化实验室.png") no-repeat  center;
}
.solution-card2:hover .card-mask{
  background-color: transparent;
  transition: all 0.5s;
}
.solution-card3{
  position: relative;
  width: 25%;
  height: 100%;
  background-size: cover;
  background: url("http://data.xiyilab.com/web/main/static/解决方案/理化生实验室banner.png") no-repeat  center;
}
.solution-card3:hover  .card-mask{
  transition: all 0.5s;
  background-color: transparent;
}
.active-solution-card{
  width: 50%;
  height: 100%;
}
.usage{
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 62.5vw;
  height: 50vw;
  margin: 2vw auto 2vw;
}
.usage-line{
  width: 100%;
  height: 4vw;
  margin-bottom: 7vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/场景波浪线.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.usage-card-group{
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.usage-mini-card{
  height: 15.625vw;
  width: 20vw;
  margin: 0.5vw;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  overflow: hidden;
}
.usage-medium-card{
  position: relative;
  height: 15.625vw;
  width: 30vw;
  margin: 0vw 0.5vw 0vw;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);

  overflow: hidden;
}
.usage-card-title{
  position: absolute;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/教室标签.png");
  width:8.3vw ;
  height: 1.8vw;
  top:2vw;
  text-align: center;
  color:white ;
  font-family: test;
  font-size: 0.8vw;
  white-space: nowrap;
  line-height: 1.8vw;
  letter-spacing: 1px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.usage-large-card{
  position: relative;
  height: 33vw;
  width: 30vw;
  margin: 0.5vw;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.bigger-img{
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  -webkit-transition: .5s;
  transition: .5s;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/普通教室.png");
  background-size: 150% 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.medium-img-1{
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  -webkit-transition: .5s;
  transition: .5s;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/多媒体教室.png");
  background-size: 125% 125%;
  background-position: center center;
}
.medium-img-2{
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  -webkit-transition: .5s;
  transition: .5s;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/理化生实验教室.png");
  background-size: 125% 125%;
  background-position: center center;
}
.mini-img-1{
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  -webkit-transition: .5s;
  transition: .5s;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/创新教室.png");
  background-size: 200% 100%;
  background-repeat: no-repeat;
  background-position: left center;
}
.mini-img-2{
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  -webkit-transition: .5s;
  transition: .5s;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/考试实训.png");
  background-size: 200% 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.mini-img-3{
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  -webkit-transition: .5s;
  transition: .5s;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/日常练习.png");
  background-size: 200% 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.usage-large-card:hover .bigger-img {

  -webkit-transform: scale(1.25, 1.25);
  transform: scale(1.25, 1.25);
}
.usage-medium-card:hover .medium-img-1 {

  -webkit-transform: scale(1.25, 1.25);
  transform: scale(1.25, 1.25);
}
.usage-medium-card:hover .medium-img-2 {

  -webkit-transform: scale(1.25, 1.25);
  transform: scale(1.25, 1.25);
}
.usage-mini-card:hover .mini-img-1 {

  -webkit-transform: scale(1.25, 1.25);
  transform: scale(1.25, 1.25);
}
.usage-mini-card:hover .mini-img-2 {

  -webkit-transform: scale(1.25, 1.25);
  transform: scale(1.25, 1.25);
}
.usage-mini-card:hover .mini-img-3 {

  -webkit-transform: scale(1.25, 1.25);
  transform: scale(1.25, 1.25);
}
.usage-card-group-right{
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 33vw;
}
.case{
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100vw;
  height: 20vw;
  margin: 2vw auto 2vw;
  overflow: hidden;
  align-items: center;
}
.case-switch-zone{
  height: 14vw;
  width: 75vw;
  margin: auto;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;

}
.switch-zone{
  width: 64vw;
  height: 12.5vw;
  position: relative;
  overflow: hidden;
}
.case-card-0{
  position: absolute;
  left:-22vw;
  width: 20vw;
  height: 100%;
  border-radius: 4px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.case-card-1{
  position: absolute;
  left:0vw;
  width: 20vw;
  height: 100%;
  border-radius: 4px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.case-card-2{
  position: absolute;
  left:22vw;
  width: 20vw;
  height: 100%;
  border-radius: 4px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.case-card-3{
  position: absolute;
  left:44vw;
  width: 20vw;
  height: 100%;
  border-radius: 4px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.case-card-4{
  position: absolute;
  left:66vw;
  width: 20vw;
  height: 100%;
  border-radius: 4px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.switch-btn{
  position: relative;
  width: 2vw;
  height: 2vw;
  line-height: 180px;
  border-radius: 50%;
  background: white;
  text-align: center;
  cursor: pointer;
}
.switch-btn i{
  background: linear-gradient(0deg,
  #0dccff 0%,
  #4760ff 100%);
  -webkit-background-clip: text;
  color: transparent;
  position: absolute;
  font-size: 1vw;
  top:0.5vw;
  left: 0.5vw;
}
.switch-btn:after{
  position: absolute;
  content: '';
  background: linear-gradient(0deg,
  #0dccff 0%,
  #4760ff 100%);
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  z-index: -1;
  transform: scale(1.05);
  border-radius: 50%;
}
.switch-btn:hover{
  background: linear-gradient(0deg,
  #0dccff 0%,
  #4760ff 100%);
  box-shadow: 0px 26px 57px 0px
  rgba(4, 171, 255, 0.4);
}
.switch-btn:hover i{
  color: white;
}
.case-more-btn{
  font-family: test;
  letter-spacing: 1px;
  height: 2vw;
  font-size: 0.8vw;
  width: 6vw;
  margin: auto;
  background-image: linear-gradient(90deg,
  #04abff 0%,
  #4f75fb 100%),
  linear-gradient(
    #5c6c7a,
    #5c6c7a);
  background-blend-mode: normal,
  normal;
  border-radius: 2vw;
  text-align: center;
  color: #fff;
  font-weight: 600;
  line-height: 2vw;

}
.produce-title{
  background: url("http://data.xiyilab.com/web/main/static/首页/-产-品-介-绍-标题.png") no-repeat  center;
  background-size: contain;
  width: 18.2vw;
  height: 6.35vw;
  margin: 0vw auto 1vw;
  position: relative;
}
.produce-back{
  position: absolute;
  width: 100vw;
  height: 48.8vw;
  left:-41vw;
  background: url("http://data.xiyilab.com/web/main/static/首页/产品介绍装饰背景.png") no-repeat left;
  z-index: -1;
  background-size: contain;
}
.solution-title-back{
  width: 100vw;
  height: 10vw;
  background-color: white;
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.solution-title{
  background: url("http://data.xiyilab.com/web/main/static/首页/-解-决-方-案-标题.png") no-repeat  center;
  background-size: contain;
  width: 15vw;
  height: 6.35vw;
  margin: 2vw auto 2vw;
}
.video-title{
  background: url("http://data.xiyilab.com/web/main/static/首页/-视-频-介-绍-标题.png") no-repeat  center;
  background-size: contain;
  width: 16vw;
  height: 6.35vw;
  margin: 0vw auto 1vw;
  position: relative;
}
.usage-title{
  background: url("http://data.xiyilab.com/web/main/static/首页/-使-用-场-景-标题.png") no-repeat  center;
  background-size: contain;
  width: 15vw;
  height: 6.35vw;
  margin: 0vw auto 1vw;
  position: relative;
}
.case-title{
  background: url("http://data.xiyilab.com/web/main/static/首页/案例展示标题.png") no-repeat  center;
  background-size: contain;
  width: 15vw;
  height: 6.35vw;
  margin: 0vw auto 1vw;
}
.video-back{
  position: absolute;
  z-index: -1;
  width: 100vw;
  top:32vw;
  left: -42vw;
  height: 31.25vw;
  background-image: linear-gradient(90deg,
  #04abff 0%,
  #4f75fb 100%),
  linear-gradient(
    #5c6c7a,
    #5c6c7a);
  background-blend-mode: normal,
  normal;
}
.video-text{
  width: 50vw;
  height: 6vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin: 18vw auto 5vw;
}
.video-text-group{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.video-text-up{
  text-align: left;
  font-family: LcdD;
  font-size: 3vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #ffffff;
  margin-bottom: 0.7vw;
}
.video-text-down{
  margin-top: 0.5vw;
  font-family: test;
  font-size: 1.2vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #ffffff;
}
.video-right-in{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/大图标做动画 1.png");
  top: 47vw;
  left: 60vw;
  z-index: 999;
  position: absolute;
  width: 18.75vw;
  height: 15.625vw;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.video-left-in{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/大图标做动画.png");
  top: 34vw;
  left: -60vw;
  z-index: 999;
  position: absolute;
  width: 17.5vw;
  height: 20vw;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.usage-back{
  position: absolute;
  left: -32.5vw;
  top:-3vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/使用场景大背景.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 90vw;

  height: 73.8vw;
}
.move-back{
  position: absolute;
  left: -41vw;
  top:5vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/使用场景背景上下浮动.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;
  width: 95vw;
  height: 65vw;
}
.footer-img{
  width: 100vw;
  height: 9vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/育见未来.png");
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.footer-btn-group{
  margin-top: 2vw;
  width: 30vw;
  height: 1.8vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
}
.footer-btn{
  width: 6vw;
  font-weight: 100;
  font-size: 0.8vw;
  font-family: test;
  border: 1px white solid;
  color: white;
  background: transparent;
  line-height:1.8vw;
  text-align: center;
  cursor: pointer;
}
</style>



